import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import './Auth.css';

function Register() {
    const navigate = useNavigate();
    const { register } = useAuth();
    const { t, language, toggleLanguage } = useLanguage();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        company: '',
        password: '',
        confirmPassword: ''
    });
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (formData.password !== formData.confirmPassword) {
            setError(language === 'ar' ? 'كلمات المرور غير متطابقة' : 'Passwords do not match');
            return;
        }

        if (formData.password.length < 6) {
            setError(language === 'ar' ? 'كلمة المرور يجب أن تكون 6 أحرف على الأقل' : 'Password must be at least 6 characters');
            return;
        }

        setLoading(true);

        try {
            const result = await register({
                name: formData.name,
                email: formData.email,
                phone: formData.phone,
                company: formData.company,
                password: formData.password
            });

            if (result.success) {
                navigate('/dashboard');
            } else {
                setError(result.message || t('registrationFailed'));
            }
        } catch (err) {
            setError(t('registrationFailed'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={`auth-page ${language === 'ar' ? 'rtl' : 'ltr'}`}>
            <div className="auth-container">
                <button onClick={toggleLanguage} className="lang-toggle">
                    🌐 {language === 'ar' ? 'English' : 'العربية'}
                </button>
                
                <div className="auth-logo">
                    <img src="/logo.png" alt="Matix ERP" />
                </div>
                
                <h1>Matix Helpdesk</h1>
                <p className="auth-subtitle">{t('createSupportAccount')}</p>

                {error && <div className="auth-error">{error}</div>}

                <form onSubmit={handleSubmit} className="auth-form">
                    <div className="form-group">
                        <label>{t('fullName')} *</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder={language === 'ar' ? 'أدخل اسمك الكامل' : 'Enter your full name'}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>{t('emailAddress')} *</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder={language === 'ar' ? 'أدخل بريدك الإلكتروني' : 'Enter your email'}
                            required
                        />
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>{t('phone')}</label>
                            <input
                                type="tel"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                placeholder={language === 'ar' ? 'رقم الهاتف' : 'Phone number'}
                            />
                        </div>
                        <div className="form-group">
                            <label>{t('company')}</label>
                            <input
                                type="text"
                                name="company"
                                value={formData.company}
                                onChange={handleChange}
                                placeholder={language === 'ar' ? 'اسم الشركة' : 'Company name'}
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label>{t('password')} *</label>
                        <div className="password-input">
                            <input
                                type={showPassword ? 'text' : 'password'}
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder={language === 'ar' ? 'أدخل كلمة المرور' : 'Enter password'}
                                required
                            />
                            <button
                                type="button"
                                className="password-toggle"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? (language === 'ar' ? 'إخفاء' : 'Hide') : (language === 'ar' ? 'إظهار' : 'Show')}
                            </button>
                        </div>
                    </div>

                    <div className="form-group">
                        <label>{t('confirmPassword')} *</label>
                        <input
                            type="password"
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            placeholder={language === 'ar' ? 'تأكيد كلمة المرور' : 'Confirm password'}
                            required
                        />
                    </div>

                    <button type="submit" className="auth-submit" disabled={loading}>
                        {loading ? (language === 'ar' ? 'جاري التسجيل...' : 'Registering...') : t('register')}
                    </button>
                </form>

                <div className="auth-divider">
                    <span>{t('haveAccount')}</span>
                </div>

                <Link to="/login" className="auth-link-btn">
                    {t('signIn')}
                </Link>

                <p className="auth-footer">© 2024 MatixERP. All rights reserved.</p>
            </div>
        </div>
    );
}

export default Register;
